import styled, { injectGlobal } from '@src/styled-components';

export const WorkflowConditions = styled.div`
`

export const DividerStyler = styled.div`
    display: flex;
    width: 95%;
    margin-top: 36px;
    .left{
        flex: 11;
    }

    .right{
        flex: 11;
    }
    .center{
        flex: 1;
        align-items: center;
        justify-content: center;
        display: flex;
    }
    .ant-divider-horizontal{
    background-color: #cecece;
    }
`

injectGlobal`    
    .ant-modal-body{
        .workflow-conditions{
        padding: 2% 0 0 3%;
        font-family: "Montserrat";
            h1,h2,h3,p{
                font-family: inherit;
                font-weight: 500;
            }
            h1{
                color: #354D62;
                font-size: 3em;
            }
            h2{
                font-size: 2em;
                color: #595959;
            }
            .process-description{
                width: 45%;
            }
        }
        .condition:not(:first-child){
            margin-top: 20px;
        }
        .condition{
            .broken{
                border: 1px solid #D93838 !important;
                box-shadow: 3px 2px 9px rgba(217, 56, 56, 0.25);
            }
        }
    }
`

export const ConditionWrapper = styled.div`
            width: 95%;
            padding: 35px;
            background-color: #fff;
            border: 1px solid #D6DDF4;
            box-sizing: border-box;
            box-shadow: 3px 2px 9px rgba(0, 0, 0, 0.15);
            border-radius: 10px;

            h3{
                color: #354D62;
                font-size: 2em;
                font-weight: 400;
            }
`

export const GhostButton = styled.button`
    background: none;
    border: none;
    font-size: 1.4em;
    color: ${props => props.color ? props.color : '#335D7C'};
    :hover{
        cursor: pointer;
    }

`

export const ConditionFooterWrapper = styled.div`
    width: 103.8%;
    transform: translateX(-34px);
    border-top: 1px solid #d6ddf4;
    .label{
        font-weight: 500;
        font-size: 1.4em;
        margin-right: 20px;
        font-family: inherit;
        color: #7E7E7E;
    }
    .wrapper-content{
        margin: 2% 0 0 2%;
        .ant-select-selection{
        width: 15vw;
        box-sizing: border-box;
            .ant-select-selection__placeholder{
                top: 8%
            }
            }
            
            .long{
                .ant-select-selection{
                    width: 25vw;
                }
            }
        }
    }
   
    .margin-left{
        display: inline;
        margin-left: 25%;
        @media (max-width: 1500px ) {
        margin-left: 22%;      
        }
    }
    .delete-icon{
      transform: translate(-1px, -4px);
    }
`

export const NewConditionWrapper = styled.div`
    width: 95%;
    border: 1px solid #335D7C;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    height: 46px;
    :hover{
        cursor: pointer;
    }
    .new-condition{
        color: #335D7C;
        font-family: inherit;
        font-size: 1.2em;
        text-transform: uppercase;
        font-weight: 600;
    }
`
export const ElseWrapper = styled.div`
    width: 95%;
    margin: 35px 0;
    box-shadow: 3px 2px 9px rgba(0, 0, 0, 0.15);
    border: 1px solid #D6DDF4;
    border-radius: 10px;
    height: 120px;
    display: flex;
    align-items: center;
    .content{
        margin-left: 5%;
    }
    .text{
        color: #7E7E7E;
        font-size: 1.3em;
        font-weight: 500;
        font-family: inherit;
    }
    .select{
        width: 350px;
        margin-left: 20px;
    }
`
export const OptionsWrapper = styled.div`
    margin-left: 72vw;
    @media (max-width: 1400px){
        margin-left: 61vw;
    }
    .pill-button{
        width: 181px;
        height: 41px;
        border: none;
        border-radius: 30px;
        color: white;
        font-weight: 600;
        text-transform: uppercase;
        background-color: #335D7C;
        :hover{
            cursor: pointer;
        }
    }
    .ghost-button{
        margin-right: 50px;
        border: none;
        background: none;
        color: #335D7C;
        font-size: 1.3em;
        font-weight: 600;
        text-transform: uppercase;
        :hover{
            cursor: pointer;
        }
    }
`